import React, { useEffect } from 'react';
import _ from 'lodash';
import useTabs from '@/hooks/useTabs';
import useRouter from '@/hooks/useRouter';
import BicesterToolbar from '@/components/layouts/BicesterToolbar';
import { getPath, MAKE_SERVICE, pageTabs } from './constants';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { ROLE_TYPE } from '@/constants';
import options from '@/utils/options';

const SubscribeServiceContext = React.createContext(null);

const SubscribeService = ({ children }) => {
  const { pathname } = useRouter();
  const { profile } = useReadyInfo();

  const { tabs, activeTab, onChangeTab } = useTabs<string>(
    pageTabs.filter((tab) =>
      options(
        {
          [ROLE_TYPE.MANAGER]: () => true,
          /**
           * GE领班：没有服务余量设置
           */
          [ROLE_TYPE.GANGER]: () =>
            ![getPath(MAKE_SERVICE.MARGIN), getPath(MAKE_SERVICE.MARGIN_QUERY)].includes(tab.url),
          /**
           * GE迎宾大使：没有服务余量设置
           */
          [ROLE_TYPE.AMBASSADOR]: () =>
            ![getPath(MAKE_SERVICE.MARGIN), getPath(MAKE_SERVICE.MARGIN_QUERY)].includes(tab.url),
          /**
           * GE兼职：没有预约模块所有服务
           */
          [ROLE_TYPE.PT]: () => false,
          /**
           * OPS安保：只有代客泊车核销
           */
          [ROLE_TYPE.OPS]: () => tab.url === getPath(MAKE_SERVICE.PARKING),
          /**
           * DRT导购大使：只有预约管理(预约服务审核)
           */
          [ROLE_TYPE.DRT]: () => tab.url === getPath(MAKE_SERVICE.MANAGE),
          default: () => true,
        },
        String(profile?.role)
      )
    )
  );

  useEffect(() => {
    const currentTab = tabs.find((tab) => pathname?.endsWith(tab.url));
    onChangeTab(currentTab?.key);
  }, [tabs, onChangeTab, pathname]);

  return (
    <div className="bicester-subscribe-service">
      <BicesterToolbar>
        <BicesterToolbar.NavBar data={tabs} activeTab={activeTab} isActiveDefault />
      </BicesterToolbar>
      <SubscribeServiceContext.Provider value={{}}>{children}</SubscribeServiceContext.Provider>
    </div>
  );
};

export default SubscribeService;
